module.exports = __webpack_public_path__ + "media/images/fr_ca/performance_index_continuum-36a23d94c468ada6ea77464d79f4e728.jpg";